
import styled from "styled-components";
import { ButtonContained, FontStyles } from "../../../components";

const SelectorContainer = styled.div(({ theme }) => {
  return {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    paddingBottom: theme.spacing(3),
  };
});

const SubmitContainer = styled.div(({ theme }) => {
  return {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "flex-end",
    paddingBottom: theme.spacing(3),
  };
});

const SelectorButton = styled(ButtonContained)(({ theme,desativado }) => {
  return {
    "&&.MuiButton-root": {
      ...FontStyles.medium16,
      paddingInline: theme.spacing(2.5),
      backgroundColor: desativado ? "white" : "#0C396D",
      paddingBlock: theme.spacing(0.5),
      marginRight: theme.spacing(1.5),
      border: `2px solid ${theme.palette.action.selected}`,
      borderRadius: 100,
      color: desativado ? "#0C396D" : "white",
      width: "auto",
      "&:hover": {
        backgroundColor: desativado ? theme.palette.background.paper : "#0C396D",
      },
    },
  };
});

const Submit = styled(ButtonContained)(({ theme,}) => {
  return {
    "&&.MuiButton-root": {
      ...FontStyles.medium16,
      paddingInline: theme.spacing(2.5),
      paddingBlock: theme.spacing(0.5),
      marginRight: theme.spacing(1.5),
      border: `2px solid ${theme.palette.action.selected}`,
      borderRadius: 100,
      color: theme.palette.text.tertiary,
      width: "auto",

      "&:disabled": {
        backgroundColor: theme.palette.action.active,
        color: theme.palette.text.secondary,
      },
      "&:hover": {
    
      },
    },
  };
});

const containerGeral = styled.div(({ theme }) => {
  return {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    padding: 14,
  };
});

const ContainerDadosBasicos = styled.div(({ theme }) => {
  return {  
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: theme.spacing(1),
    padding: theme.spacing(2),
    backgroundColor:'white',
    borderRadius: 8,
  };
});

const FormContainer = styled.div(({ theme }) => {
  return {
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: theme.spacing(1),
  };
});

const ContainerSecondary = styled.div(({ theme }) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    backgroundColor: theme.palette.action.selected,
    padding: "16px 20px",
    borderRadius: "15px",

    width: "100%",
    marginBottom: theme.spacing(1.5),
    height: "fit-content",

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "flex-end",
      gap: "8px",
    },
  };
});

const RegitryContainer = styled.div(({ theme }) => {
  return {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(3),
    gap: theme.spacing(0.75),
  };
});

const RegitryButton = styled(ButtonContained)(({ theme }) => {
  const { palette: colors, spacing } = theme;
  return {
    "&&.MuiButton-root": {
      backgroundColor: "white",
      color: colors.text.primary,
      padding: theme.spacing(2),
      borderRadius: "30px",
      width: "8vw",
      marginTop: 0,
      ...FontStyles.medium14,

      "&:hover": {
        backgroundColor: colors.primary.contrastText,
      },

      "& .MuiButton-label": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
  };
});

const Container = styled.div(({ theme, $dark, $row }) => {
  return {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    backgroundColor: $dark
      ? theme.palette.action.selected
      : theme.palette.background.paper,

    borderRadius: "15px",

    width: "100%",
    marginBottom: theme.spacing(1.5),
    height: "fit-content",
  };
});

const Styles = {
    // Gerais
    SelectorContainer,
    SelectorButton,
    containerGeral,
    Submit,

    // Tela Dados básicos
    ContainerDadosBasicos,
    FormContainer,
    SubmitContainer,

    // tela Minhas Reservas
    ContainerSecondary,
    RegitryContainer,
    RegitryButton,
    Container,
};

export default Styles;
